export default {
	IDLE: "IDLE",
	FETCHING: "FETCHING",
	ERROR: "ERROR",
};
